import { IOfferCard } from '../../../../types';
import { getAgentExperience } from '../../utils';

export const prepareAgentInfo = (offerCard: IOfferCard): string | undefined => {
  const { isByHomeowner, isTop3, offerUser } = offerCard;

  if (isByHomeowner) {
    return;
  }

  const experience = getAgentExperience(offerCard);

  if (isTop3 && experience) {
    return experience;
  }

  if (offerUser?.subAgentCompanyName && !offerUser.masterAgent) {
    return offerUser.subAgentCompanyName;
  }

  return;
};
